export const CHECKOUT_PAYMENT_RECEIVED = 'ETM_CHECKOUT_PAYMENT_RECEIVED';
export const CHECKOUT_PAYMENT_FAILED = 'ETM_CHECKOUT_PAYMENT_FAILED';
export const CHECKOUT_PAYMENT_STATE_UNKNOWN = 'ETM_CHECKOUT_PAYMENT_STATE_UNKNOWN';

export const WindowEventDiscriminators = {
  CHECKOUT_PAYMENT_RECEIVED,
  CHECKOUT_PAYMENT_FAILED,
  CHECKOUT_PAYMENT_STATE_UNKNOWN
}
